import { createContext } from "react";

const ProyectosContext = createContext();

export default ProyectosContext;
